import { render, staticRenderFns } from "./Sold.vue?vue&type=template&id=0d523654&scoped=true"
import script from "./Sold.vue?vue&type=script&lang=js"
export * from "./Sold.vue?vue&type=script&lang=js"
import style0 from "./Sold.vue?vue&type=style&index=0&id=0d523654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d523654",
  null
  
)

export default component.exports